export default "__VITE_ASSET__DWUuFg81__"